import React, { useEffect, useState } from "react";
import { apiGet } from "../../utils/api";

const ThesisList = (props) => {
  const [thesisList, setThesisList] = useState([]);

  async function exibir() {
    let payload = {};
    payload = apiGet("/thesis");
    const data = (await payload).data.data;
    return data;
  }

  useEffect(() => {
    exibir().then(
      (data) => {
        setThesisList(data);
      },
      () => {}
    );
  }, []);

  var subset = null;

  if (thesisList && thesisList.length) {
    subset = thesisList.slice(0, props.thesisToShow);
  }

  return (
    <>
      {subset
        ? subset.map((thesis) => {
            return (
              <div className="card mb-3" key={thesis.thesis_id}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card-body">
                      <h5 className="card-title">{thesis.title}</h5>
                      <p className="card-text m-0">
                        <small className="text-muted">{thesis.year}</small>
                      </p>
                      <p className="card-text m-0">
                        <small className="text-muted">{thesis.type}</small>
                      </p>
                      <p className="card-text m-0">
                        <small className="text-muted">{thesis.author}</small>
                      </p>
                      <p className="card-text m-0">
                        <a
                          className="link link--dia"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={thesis.access_link}
                        >
                          Acessar o trabalho
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        : null}
    </>
  );
};

export default ThesisList;
